import { isNotEmpty } from "../../../../../../../../helpers/utils";

export const checkAllowBillingToChangeInvoice = (
  billingSchedules: string,
  billingType: string,
  isChangeFirstTimeBillingType: boolean,
) => {
  if (isNotEmpty(billingSchedules)) {
    return false;
  } else if (billingType && isChangeFirstTimeBillingType) {
    return false;
  } else {
    return true;
  }
};
